import "core-js/modules/es.array.push.js";
import LNav from './nav.vue';
import QueryString from 'qs';
import Cookies from 'js-cookie';
export default {
  name: 'LHead',
  components: {
    LNav
  },
  data() {
    return {
      isExitHover: false,
      isLogin: false,
      info: {},
      avatarUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    };
  },
  computed: {},
  watch: {},
  created() {
    debugger;
    let token = process.env.NODE_ENV === 'production' ? Cookies.get('cosmoplat-cosmoplatuuctoken') : Cookies.get('test-cosmoplat-cosmoplatuuctoken');
    if (token) {
      debugger;
      this.isLogin = true;
      this.info = JSON.parse(sessionStorage.getItem('info'));
    }
  },
  mounted() {},
  methods: {
    handleSelect(key) {
      key && this.$router.push(key);
    },
    handleGo() {
      window.open('https://www.cosmoplat.com/');
    },
    handleGoBaas() {
      this.$router.push('/baas');
    },
    handleLogin() {
      this.$store.dispatch('interfacegGetUserInfo');
    },
    handleLogout() {
      this.$store.dispatch('interfaceLogout').then(res => {
        this.isLogin = false;
        location.href = res.logoutURL + '?' + QueryString.stringify({
          redirect_uri: window.location.origin
        });
      });
    }
  }
};